import React from 'react';
import { useReserveComputationTable } from '../../lib';
import { DateRangeSelect } from '@shared/UI';
import './ReserveComputationTableFilters.scss';
import { formats } from '@shared/utils';

export const ReserveComputationTableFilters: React.FC = () => {
    const { dateRange, setDateRange } = useReserveComputationTable();

    return (
        <div className='widget-reserve-computation-table-filters'>
            <DateRangeSelect
                currentValue={dateRange}
                format={formats.dateWithYear}
                firstPlaceholder={'Select Date'}
                dropdownPlacement='bottom-left'
                onDateRangeSelect={setDateRange}
            />
        </div>
    );
};
